"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var DiagramLayoutSettings = /** @class */ (function () {
    function DiagramLayoutSettings() {
        this.BranchSpacing = 50;
        this.DefaultAssistantLayoutStrategyId = null;
        this.DefaultLayoutStrategyId = null;
        this.BranchSpacing = 50;
        this.LayoutStrategies = new Map();
    }
    DiagramLayoutSettings.prototype.RequireDefaultLayoutStrategy = function () {
        var id = this.DefaultLayoutStrategyId;
        if (!id) {
            throw new Error("DefaultLayoutStrategyId is null or not valid");
        }
        var result = this.LayoutStrategies.get(id);
        if (!result) {
            throw new Error("DefaultLayoutStrategyId is null or not valid");
        }
        return result;
    };
    DiagramLayoutSettings.prototype.RequireDefaultAssistantLayoutStrategy = function () {
        var id = this.DefaultAssistantLayoutStrategyId;
        if (!id) {
            throw new Error("RequireDefaultAssistantLayoutStrategy is null or not valid");
        }
        var result = this.LayoutStrategies.get(id);
        if (!result) {
            throw new Error("RequireDefaultAssistantLayoutStrategy is null or not valid");
        }
        return result;
    };
    return DiagramLayoutSettings;
}());
exports.default = DiagramLayoutSettings;
